import {useLabelsLiveUpdates} from '../../../hooks/use-labels-live-updates'
import {useLayoutQuery} from '../../../page-data/loaders/use-layout-query'
import {useLabelsQuery} from './route-queries'

export function useLabels() {
  const {data: layoutData} = useLayoutQuery()
  useLabelsLiveUpdates(layoutData?.aliveChannels)

  return useLabelsQuery()
}
